import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class PagamentosService extends CRUDService{
    constructor() {
        super("pagamento");
    }

    listarLotes(filtro) {
        return http.post("/"+this.serviceName+"/lotes", filtro);
    }

    detalhesLote(loteId) {
        return http.get("/"+this.serviceName+"/detalhes-lote/"+loteId);
    }

    listarPagamentosPendentes() {
        return http.get("/"+this.serviceName);
    }

    enviarNotaFiscal(notaFiscal) {
        return http.post("/"+this.serviceName+"/enviar", notaFiscal);
    }

    reenviarLotePagamento(id) {
        return http.post("/"+this.serviceName+"/reenviar/"+id);
    }
}